import { withSvgIcon } from './withSvgIcon';

export const DownTriangle = withSvgIcon(
  <path
    d="M0.78054 0.318182H13.8906L7.3331 11.1364L0.78054 0.318182Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 14 12' },
);
